import { t } from '../../../RI18n';
import ErrorBoundary from '../../../utils/ErrorBoundary';

class ReportStatusErrorBoundary extends ErrorBoundary {
  constructor(props) {
    super(props);
    this.state.errorSubtitle = t('dashboard.report_status.error');
  }
}

export default ReportStatusErrorBoundary;
